import React from 'react';

import { Navigation } from 'components/Navigation/Navigation';
import { PaymentStep } from 'components/PaymentStep/PaymentStep';
import { useWizard } from 'components/Wizard/components/context';
import { CARD_FORM } from 'constants/index';
import { useTranslations } from 'utils/translations/useTranslations';

import { SurchargeCardForm } from './SurchargeCardForm/SurchargeCardForm';

const SurchargeCardFormWrapper = () => {
  const i18n = useTranslations();

  const { goToPrevStep } = useWizard();

  const navigation = (
    <Navigation
      hideNext
      onClickPrev={goToPrevStep}
      nextStepName={i18n.t('stepsList.track')}
    />
  );

  return (
    <PaymentStep navigation={navigation} stepName={CARD_FORM} hasForm={false}>
      <SurchargeCardForm />
    </PaymentStep>
  );
};

export { SurchargeCardFormWrapper };
